"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./CalendarPickerHeader1.css");
var react_1 = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var __1 = require("../../..");
var string_1 = require("../../../utils/string");
var CalendarPickerHeader1Comp = function (props) {
    var dropdownDescribeId = react_1.useRef(string_1.getRandomString());
    // return index of first dropdownItem matching the parameter date month and year
    function getIndexOfItemWithMonthAndYear(date) {
        var index = -1;
        for (var i = 0; i < props.dropdownItems.length; ++i) {
            var item = props.dropdownItems[i];
            if (moment_1.default(item.date).month() === moment_1.default(date).month() &&
                moment_1.default(item.date).year() === moment_1.default(date).year()) {
                index = i;
                break;
            }
        }
        return index;
    }
    return (react_1.default.createElement("div", { className: 'CalendarPickerHeader1' },
        react_1.default.createElement("span", { id: dropdownDescribeId.current, className: 'sr-only' },
            moment_1.default(props.date).format('MMM yyyy') + '.',
            " Press enter to select month from dropdown"),
        react_1.default.createElement(__1.Select, { "aria-label": 'CalendarPicker Dropdown', "aria-describedby": dropdownDescribeId.current, selectItems: props.dropdownItems.map(function (item) { return (__assign(__assign({}, item), { value: item.date })); }), selectedIndex: getIndexOfItemWithMonthAndYear(props.date), theme: __1.SelectTheme.box, icon: __1.IconType.chevronDown, onChange: function (item) {
                props.changeYear(moment_1.default(item.value).year());
                props.changeMonth(moment_1.default(item.value).month());
            } }),
        react_1.default.createElement("div", { className: "react-datepicker__current-month" }, moment_1.default(props.date).format('MMM yyyy')),
        react_1.default.createElement("button", { type: "button", className: "react-datepicker__navigation react-datepicker__navigation--previous", "aria-label": "Previous Month", disabled: props.prevMonthButtonDisabled, onClick: props.decreaseMonth }, "Previous Month"),
        react_1.default.createElement("button", { type: "button", className: "react-datepicker__navigation react-datepicker__navigation--next", "aria-label": "Next Month", disabled: props.nextMonthButtonDisabled, onClick: props.increaseMonth }, "Next Month")));
};
exports.CalendarPickerHeader1 = react_1.default.memo(CalendarPickerHeader1Comp);
